/**
 * Created by Christof Sander on 20.09.2016.
 */

// const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'subActions'
	],

	formMapping: {
		cols: [
			[
				{ type: 'buttons', buttons: [
					{ buttonType: 'insert', context: 'tagScope', mode: 'root', text: 'Neuer TagScope' }
				] }
			]
		]
	}
};
